/* eslint-disable import/no-anonymous-default-export */
export default {
  contactInfo: "Contact info",
  email: "Email",
  phone: "Phone",
  groups: "Groups in common",
};
